export const shareLayerUsers = (state = [], action) => {
  switch (action.type) {
    case 'ADD_SHARE_LAYER_USER':
      return [...state, action.payload.user];
    case 'ADD_SHARE_LAYER_USERS':
      return [...state, ...(action.payload.users || [])];
    case 'REMOVE_SHARE_LAYER_USER':
      return state.filter(
        (user) => action.payload.user.username !== user.username,
      );
    case 'CLEAR_SHARE_LAYER_USERS':
      return [];
    default:
      return state;
  }
};
